import React from 'react';
import './App.css';
import { LOGO_URL } from './configs/urlConfigs';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img className="logo-height App-logo" src={LOGO_URL} alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default App;
